<div [formGroup]="fg()">
  <div class="action-setting">
    <div class="action-setting-title">
      {{ 'commonActions.playbookAuthenticationMode.description' | labelsProvider }}
    </div>

    <mat-radio-group [value]="authenticationMode()" (change)="onRadioButtonChange($event.value)">
      <div class="radio-option">
        <mat-radio-button [value]="authenticationModeEnum.invoker">
          {{ 'commonActions.playbookAuthenticationMode.userContextTitle' | labelsProvider }}
        </mat-radio-button>
        <div class="radio-description">
          {{ 'commonActions.playbookAuthenticationMode.userContextDescription' | labelsProvider }}
        </div>
      </div>

      <div class="radio-option">
        <mat-radio-button [value]="authenticationModeEnum.maker">
          {{ 'commonActions.playbookAuthenticationMode.authorContextTitle' | labelsProvider }}
        </mat-radio-button>
        <div class="radio-description">
          {{ 'commonActions.playbookAuthenticationMode.authorContextDescription' | labelsProvider }}
        </div>
      </div>
    </mat-radio-group>
  </div>
</div>
